exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label{font-size:16px;display:block;text-align:left;font-weight:700;padding:.25rem}.input-field{height:50px;box-sizing:border-box;width:100%;padding:.8rem;display:inline-block;box-shadow:none;font-weight:600;font-size:.8rem;border-radius:6px;border:1px solid #ddd;line-height:1.2;background:#fcfcfc;margin-top:.1rem;margin-bottom:.8rem;background:linear-gradient(90deg,#fff 50%,#fcfcfc 0);background-size:200% 100%;background-position:100% 100%;transition:all .3s ease-in-out;font-size:18px;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4010a7c1","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/InfoCard.vue
// module id = 595
// module chunks = 0